export const SearchCommonRefinement = {
  ACTION_DATE: 'actionDate',
  AREAS_OF_FOCUS: 'areasOfFocus',
  LOCATION_TYPE: 'locationType',
  LOCALE: 'locale',
  ORG_TYPE: 'orgType',
  RADIUS: 'radius',
  SOURCE: 'source',
  RECENCY: 'recency',
} as const;

export const SEARCH_COMMON_REFINEMENT_NAMES = Object.values(
  SearchCommonRefinement,
);

export const SEARCH_COMMON_REFINEMENT_LABELS = Object.defineProperties(
  {},
  {
    [SearchCommonRefinement.AREAS_OF_FOCUS]: {
      get: () => getText('Cause Areas'),
      enumerable: true,
    },
    [SearchCommonRefinement.ACTION_DATE]: {
      get: () => getText('Date'),
      enumerable: true,
    },
    [SearchCommonRefinement.LOCALE]: {
      get: () => getText('Listing Language'),
      enumerable: true,
    },
    [SearchCommonRefinement.LOCATION_TYPE]: {
      get: () => getText('Location Type'),
      enumerable: true,
    },
    [SearchCommonRefinement.ORG_TYPE]: {
      get: () => getText('Org Type'),
      enumerable: true,
    },
    [SearchCommonRefinement.RADIUS]: {
      get: () => getText('Radius'),
      enumerable: true,
    },
    [SearchCommonRefinement.RECENCY]: {
      get: () => getText('Recency'),
      enumerable: true,
    },
  },
) as Record<SearchCommonRefinementType, string>;

export type SearchCommonRefinementType =
  (typeof SearchCommonRefinement)[keyof typeof SearchCommonRefinement];
